<script lang="ts" setup>
import {Source} from "@/domain/type/source.type.ts";
import {computed, type ModelRef, ref} from "vue";
import SourceCreateBtn from "@/components/Source/SourceCreateBtn.vue";

const props = defineProps<{
  exclude: Source[],
  sourceList: Source[]
}>();
const model: ModelRef<Source> = defineModel({default: Source.EVA});
const showMenu = ref(false)

const items = computed(() => {
  return props.sourceList.filter((value) => {
    return value !== model.value && !props.exclude.includes(value)
  })
})


function bgClass() {
  switch (model.value) {
    case Source.AMMON:
      return 'bg-red'
    case Source.EVA:
      return 'bg-blue-grey'
    case Source.SIREN:
      return 'bg-french'
  }
}


</script>

<template>
  <div :class="bgClass()" class="d-flex justify-space-between align-center sourceSelect overflow-hidden" style="min-height: 52px;">
    <div class="flex-0-0" style="min-width: 64px"></div>
    <div class="flex-0-0 sourceSelect d-flex align-center" style="min-height: 52px;">
      <v-select
        v-model="model"
        :items="items"
        :menu="showMenu"
        density="compact"
        hide-details
        noDataText="Aucune autre source disponible"
        variant="plain"
      >
        <template v-slot:selection="{item}">
          <div class="ml-5 item-title">
            {{ item.title }}
          </div>
        </template>
        <template v-slot:item="{item, props}">
          <v-list-item class="cursor-pointer" v-bind="props">
            <template #prepend>
              <img v-if="item.value === Source.AMMON " alt="ammon" class="selectOptionImg" src="@/assets/img/ammon.png">
              <img v-if="item.value === Source.EVA " alt="eva" class="selectOptionImg" src="@/assets/img/eva.png">
              <img v-if="item.value === Source.SIREN " alt="siren" class="selectOptionImg" src="@/assets/img/sirene.png">
            </template>
            <template #title>
              <div class="ml-5 item-title">
                {{ item.title }}
              </div>
            </template>
          </v-list-item>
        </template>
      </v-select>
    </div>
    <source-create-btn :origin-source="model"/>
  </div>

</template>

<style lang="scss" scoped>
.selectOptionImg {
  width: 50px;
}

.item-title {
  text-transform: capitalize;
}

.sourceSelect {
  min-width: 50px;
}

.bg-french {
  background: linear-gradient(90deg, #002654 0%, #002654 30%, #FFFFFF 31%, #FFFFFF 69%, #ED2939 70%, #ED2939 100%);
}

@media (max-width: 600px) {
  .sourceSelect {
    justify-content: center !important;
  }

  .sourceSelect .flex-0-0:first-child {
    display: none;
  }

  .item-title {
    margin-left: 0 !important;
    text-align: center;
  }
}
</style>
